import type { HttpClient } from '../core/http.js';
import type { Page, RequestOptions } from '../types/common.js';
import type { BankAccount, ListBankAccountsParams } from '../types/bank.js';

/**
 * Read-only access to your bank accounts. Scope: `bank-accounts:read`.
 *
 * @remarks
 * Write operations (`create`, `update`, `remove`, `rotate-ingest-secret`,
 * `subscribe`) are intentionally **not** exposed. There is no
 * `bank-accounts:write` scope, `rotate-ingest-secret` returns a plaintext
 * secret, and `subscribe` spends money — none of which belongs behind a
 * read-scoped token. Use the dashboard for those.
 */
export class BankAccountsResource {
  constructor(private readonly http: HttpClient) {}

  list(
    params: ListBankAccountsParams = {},
    options: RequestOptions = {},
  ): Promise<Page<BankAccount>> {
    return this.http.requestList<BankAccount>('GET', '/bank-accounts', {
      ...options,
      query: params as Record<string, unknown>,
    });
  }

  retrieve(id: string, options: RequestOptions = {}): Promise<BankAccount> {
    return this.http.request<BankAccount>(
      'GET',
      `/bank-accounts/${encodeURIComponent(id)}`,
      options,
    );
  }
}
